import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Empregador } from '../../api.service';

@Component({
  selector: 'app-painel-registro-manual',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './painel-registro-manual.component.html'
})
export class PainelRegistroManualComponent {
  @Input() empregadores: Empregador[] = [];
  @Input() empregadorSelecionado = '';

  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() iniciarRegistro = new EventEmitter<void>();

  selecionarEmpregador(empregadorId: string) {
    this.empregadorSelecionadoChange.emit(empregadorId);
  }
}
